import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './ContentLoader.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      staticStyle: { display: "flex" },
      attrs: {
        viewBox: _vm.viewBox,
        width: _vm.width,
        height: _vm.height,
        version: "1.1",
        preserveAspectRatio: _vm.preserveAspectRatio
      }
    },
    [
      _c("rect", {
        style: _vm.fill,
        attrs: {
          color: "yellow",
          "clip-path": _vm.clipPath,
          x: "0",
          y: "0",
          width: "100%",
          height: "100%"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "clipPath",
            { attrs: { id: _vm.idClip } },
            [
              !_vm.$slots["default"]
                ? _c("rect", {
                    attrs: {
                      x: "0",
                      y: "0",
                      rx: "3",
                      ry: "3",
                      width: "100%",
                      height: "100%"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            { attrs: { id: _vm.idGradient } },
            [
              _c(
                "stop",
                {
                  attrs: {
                    offset: "0%",
                    "stop-color": _vm.primaryColor,
                    "stop-opacity": _vm.primaryOpacity
                  }
                },
                [
                  _vm.animate
                    ? _c("animate", {
                        attrs: {
                          attributeName: "offset",
                          values: "-2; 1",
                          dur: _vm.speed,
                          repeatCount: "indefinite"
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "stop",
                {
                  attrs: {
                    offset: "50%",
                    "stop-color": _vm.secondaryColor,
                    "stop-opacity": _vm.secondaryOpacity
                  }
                },
                [
                  _vm.animate
                    ? _c("animate", {
                        attrs: {
                          attributeName: "offset",
                          values: "-1.5; 1.5",
                          dur: _vm.speed,
                          repeatCount: "indefinite"
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "stop",
                {
                  attrs: {
                    offset: "100%",
                    "stop-color": _vm.primaryColor,
                    "stop-opacity": _vm.primaryOpacity
                  }
                },
                [
                  _vm.animate
                    ? _c("animate", {
                        attrs: {
                          attributeName: "offset",
                          values: "-1; 2",
                          dur: _vm.speed,
                          repeatCount: "indefinite"
                        }
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ContentLoader/ContentLoader.vue.js